/* eslint-disable no-console */
import { register } from "register-service-worker";

if (process.env.NODE_ENV === "production") {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {},
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {},
    updatefound() {
      console.log("New content is downloading.");
    },
    updated(registration) {
      console.log("New content is available.");
      document.dispatchEvent(
        new CustomEvent("swUpdated", { detail: registration })
      );
    },
    offline() {},
    error(error) {
      console.error("Error during service worker registration:", error);
    }
  });
}
